import fetcher from '@/services/fetcher'
import type { DepositBonusOption, DepositBonusOptionResponse } from '@/types'
import type { TProductSku } from '@/utils/helper-objects'
import { toPortalUrl } from '@/utils/url-generation-utils'

/**
 * Fetch eligible deposit options from the API.
 *
 * Each entry is either a catalog product (normal credit pack/top‑up) or a promotion (like the welcome bonus).
 *
 * @param {Map<TProductSku, DepositBonusOption>} map
 * @returns {Promise<{ data: Ref<DepositBonusOptionResponse | null>, error: Ref<Error | null> }>}
 */
export async function fetchDepositOptions(
  map?: Map<TProductSku, DepositBonusOption>
) {
  const { data, error } = await fetcher.get<DepositBonusOptionResponse>(
    toPortalUrl('deposit-options'),
    true
  )

  // Manually map the array since AfterFetchParser only handles top-level objects
  if (data.value?.eligible_products && map) {
    map.clear() // Clear existing entries

    for (const option of data.value.eligible_products) {
      map.set(option.sku, option)
    }
  }

  return { data, error }
}
